import React from "react";
import { Row, Col, Tabs} from "antd";
import ResultChart from "../ResultChart";
import Loader from "../../../components/Loader";
import { categories } from "../../../pages/Evaluation/questions";

const TabPane = Tabs.TabPane;
const danishText =
  "Du har ny udfyldt en selv-evaluering; en besvarelse af Institute of Leadership Dynamics A/S Leadelsesevaluering. Selve evalueringen bygger på de 71 spørgsmål du netop har besvaret. Disse er fordelt på 12 overordnede grupper eller parametre. De 12 parametre beskriver kvaliteter og egenskaber som er vigtige i rollen som leder - både i forbindelse med ledelse af andre og i konteksten af at lede sig selv.";
const englishText =
  "You have now completed a self-assessment. The assessment is based on the 71 questions you have just answered. These are divided into 12 parameters with 5 or 6 questions under each. The parameters describe qualities and attributes that are important in the role as leader - both in leading others and in the context of leading self.";
export function renderText(language) {
  switch (language) {
    case "en":
      return englishText;
    case "dk":
      return danishText;
    default:
      return danishText;
  }
}

function Analysis(props) {
  const { peer1Name, peer2Name, peer3Name } = props;
  return (
    <Row
      className="survey_content_container survey_results_container admin_results"
      style={{ color: "#fff" }}
    >
      <Col md={{ span: 24 }} xs={24}>
        <Row>
          <Col md={{ span: 18 }} xs={24}>
            <Row gutter={16}>
              <Col md={{ span: 12, offset: 6 }} xs={24}>
                <Row gutter={16}>
                  <Col md={24} style={{ marginTop: "20px" }}>
                    <h1 style={{ marginBottom: 0 }}>
                      {categories["360"][props.highlight] &&
                        categories["360"][props.highlight].dk}
                    </h1>
                  </Col>
                </Row>
              </Col>
              <Col md={24}>
                {props.loading ? (
                  <Loader invert />
                ) : (
                  [
                    <ResultChart
                      data={props.data}
                      highlight={props.highlight}
                      language={props.language}
                      ownName={props.ownName}
                      stroke_Color={"#fff"}
                      tick_Color={"#fff"}
                      peer1Name={peer1Name}
                      peer2Name={peer2Name}
                      peer3Name={peer3Name}
                      chartHeight="600px"
                    />
                  ]
                )}
              </Col>
            </Row>
          </Col>
          <Col md={6} style={{ backgroundColor: "#fff" }}>
            <div className="navWide">
              <div className="wideDiv">
                <div
                  style={{
                    padding: "10px 0",
                    color: "#fff",
                    fontSize: "20px",
                    borderBottom: "1px solid #000",
                    backgroundColor: "#001529"
                  }}
                >
                  Kategorier
                </div>
                <Tabs
                  defaultActiveKey={props.highlight}
                  tabPosition="vertical"
                  onChange={key => props.changeAnalysisTab(key)}
                >
                  {Object.keys(categories["360"]).map(item => {
                    return (
                      <TabPane tab={categories["360"][item].dk} key={item} />
                    );
                  })}
                </Tabs>
              </div>
            </div>
          </Col>
        </Row>
      </Col>
    </Row>
  );
}

export default Analysis;

Analysis.defaultProps = {
  data: []
};



// WEBPACK FOOTER //
// ./src/pages/Admin/ResultDocument/Analysis.js